import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=37d68096&scoped=true"
import script from "./ProfileCard.vue?vue&type=script&lang=js"
export * from "./ProfileCard.vue?vue&type=script&lang=js"
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=37d68096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d68096",
  null
  
)

export default component.exports